import axios from "axios";
import objectToFormData from "../../objectToFormData";

export default async function getWithPaginationRequest(data) {
    try {
        return await axios.post(`/rest/clients/get-with-pagination`, objectToFormData(data));
    } catch (error) {
        throw error;
    }
}
